import React from "react";
import {connect} from "react-redux";

import {openModal} from "../../actions/modalActions";

import * as auth from "../../utils/auth";
import {Button} from "reactstrap";
import InfoBox from "../InfoBox";
import {login, register} from "../../actions/authActions";

class Login extends React.PureComponent {

  render() {
    let user = auth.get_user();

    if (user)
      return <InfoBox title="My account">
        <React.Fragment>
          <p>You're currently logged in as {user.sub}</p>
          <p>{user.roles ? "Roles: "+JSON.stringify(user.roles) : "You have no roles" }</p>
          <p><Button className="mr-2" color="danger" onClick={() => this.props.dispatch(openModal({
            id: 1,
            type: 'confirm',
            title: 'Are you sure you want to log out?',
            onConfirm: () => {localStorage.removeItem('token'); window.location.reload()},
          }))}>Logout</Button></p>
          <p><Button className="mr-2" color="success" onClick={() => this.props.dispatch(openModal({
            id: 1,
            type: 'input',
            title: 'Register',
            inputs: [
              {id:'username', type: 'text', placeholder: 'Username..'},
              {id:'password', type: 'password', placeholder: 'Password..'},
            ],
            onConfirm: ({username, password}) => {this.props.register(username, password)},
          }))}>Register</Button></p>
        </React.Fragment>
      </InfoBox>

    return <InfoBox title="Log in">
      <p>You're not logged in</p>
      <p><Button className="mr-2" color="success" onClick={() => this.props.dispatch(openModal({
        id: 1,
        type: 'input',
        title: 'Login',
        inputs: [
          {id:'username', type: 'text', placeholder: 'Username..'},
          {id:'password', type: 'password', placeholder: 'Password..'},
        ],
        onConfirm: ({username, password}) => {this.props.login(username, password)},
      }))}>Login</Button></p>
      </InfoBox>
  }



}
// wraps dispatch to create nicer functions to call within our component
const mapDispatchToProps = (dispatch) => ({
  dispatch: dispatch,
  login: (username, password) => dispatch(login(username, password)),
  register: (username, password) => dispatch(register(username, password)),
})

const mapStateToProps = (state) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(Login)


// WEBPACK FOOTER //
// ./src/components/Login/index.js